// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* line 1, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
.bpp-properties-tab-bar {
  border-bottom: 1px solid #ccc;
  padding: 0 15px;
}
/* line 5, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
.bpp-properties-tab-bar .scroll-tabs-button {
  cursor: pointer;
  font-size: 16px;
  padding: 3px 4px 3px 4px;
  color: #666;
}
/* line 11, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
.bpp-properties-tab-bar .scroll-tabs-button:hover {
  font-weight: bold;
}
/* line 15, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
.bpp-properties-tab-bar .scroll-tabs-button.scroll-tabs-left {
  float: left;
  margin-left: -15px;
}
/* line 20, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
.bpp-properties-tab-bar .scroll-tabs-button.scroll-tabs-right {
  float: right;
  margin-right: -15px;
}
/* line 27, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
.bpp-properties-tab-bar:not(.scroll-tabs-overflow) .scroll-tabs-button {
  display: none;
}
/* line 33, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
ul.bpp-properties-tabs-links {
  margin: 5px 0 -1px 0;
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
}
/* line 39, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
ul.bpp-properties-tabs-links > li {
  display: inline-block;
  margin: 0;
}
/* line 43, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
ul.bpp-properties-tabs-links > li.bpp-hidden {
  display: none;
}
/* line 47, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
ul.bpp-properties-tabs-links > li > a {
  display: inline-block;
  font-size: 12px;
  padding: 4px 7px;
  border: 1px solid #ccc;
  border-radius: 3px 3px 0 0;
  border-bottom: transparent;
  background-color: #f8f8f8;
  color: #666;
  text-decoration: none;
}
/* line 62, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
ul.bpp-properties-tabs-links > li > a:hover {
  color: #4d4d4d;
}
/* line 68, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
ul.bpp-properties-tabs-links > li + li {
  margin-left: 4px;
}
/* line 74, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
ul.bpp-properties-tabs-links > li.bpp-active a {
  padding-bottom: 5px;
  border-top: 2px solid #52B415;
  border-bottom: none;
}
/* line 83, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
.bpp-properties-tab,
.bpp-properties-tab.bpp-hidden {
  display: none;
}
/* line 88, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */
.bpp-properties-tab.bpp-active {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./ModuleViews/Administration/BusinessProcesses/css/tabs.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA,mEAAmE;AACnE;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,WAAW;AACb;AACA,oEAAoE;AACpE;EACE,iBAAiB;AACnB;AACA,oEAAoE;AACpE;EACE,WAAW;EACX,kBAAkB;AACpB;AACA,oEAAoE;AACpE;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA,oEAAoE;AACpE;EACE,aAAa;AACf;AACA,oEAAoE;AACpE;EACE,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;AACA,oEAAoE;AACpE;EACE,qBAAqB;EACrB,SAAS;AACX;AACA,oEAAoE;AACpE;EACE,aAAa;AACf;AACA,oEAAoE;AACpE;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;AACA,oEAAoE;AACpE;EACE,cAAc;AAChB;AACA,oEAAoE;AACpE;EACE,gBAAgB;AAClB;AACA,oEAAoE;AACpE;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA,oEAAoE;AACpE;;EAEE,aAAa;AACf;AACA,oEAAoE;AACpE;EACE,cAAc;AAChB","sourcesContent":["/* line 1, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\n.bpp-properties-tab-bar {\n  border-bottom: 1px solid #ccc;\n  padding: 0 15px;\n}\n/* line 5, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\n.bpp-properties-tab-bar .scroll-tabs-button {\n  cursor: pointer;\n  font-size: 16px;\n  padding: 3px 4px 3px 4px;\n  color: #666;\n}\n/* line 11, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\n.bpp-properties-tab-bar .scroll-tabs-button:hover {\n  font-weight: bold;\n}\n/* line 15, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\n.bpp-properties-tab-bar .scroll-tabs-button.scroll-tabs-left {\n  float: left;\n  margin-left: -15px;\n}\n/* line 20, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\n.bpp-properties-tab-bar .scroll-tabs-button.scroll-tabs-right {\n  float: right;\n  margin-right: -15px;\n}\n/* line 27, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\n.bpp-properties-tab-bar:not(.scroll-tabs-overflow) .scroll-tabs-button {\n  display: none;\n}\n/* line 33, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\nul.bpp-properties-tabs-links {\n  margin: 5px 0 -1px 0;\n  padding: 0;\n  white-space: nowrap;\n  overflow: hidden;\n}\n/* line 39, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\nul.bpp-properties-tabs-links > li {\n  display: inline-block;\n  margin: 0;\n}\n/* line 43, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\nul.bpp-properties-tabs-links > li.bpp-hidden {\n  display: none;\n}\n/* line 47, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\nul.bpp-properties-tabs-links > li > a {\n  display: inline-block;\n  font-size: 12px;\n  padding: 4px 7px;\n  border: 1px solid #ccc;\n  border-radius: 3px 3px 0 0;\n  border-bottom: transparent;\n  background-color: #f8f8f8;\n  color: #666;\n  text-decoration: none;\n}\n/* line 62, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\nul.bpp-properties-tabs-links > li > a:hover {\n  color: #4d4d4d;\n}\n/* line 68, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\nul.bpp-properties-tabs-links > li + li {\n  margin-left: 4px;\n}\n/* line 74, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\nul.bpp-properties-tabs-links > li.bpp-active a {\n  padding-bottom: 5px;\n  border-top: 2px solid #52B415;\n  border-bottom: none;\n}\n/* line 83, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\n.bpp-properties-tab,\n.bpp-properties-tab.bpp-hidden {\n  display: none;\n}\n/* line 88, node_modules\\bpmn-js-properties-panel\\styles\\tabs.less */\n.bpp-properties-tab.bpp-active {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
